var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeloitte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 182 34",
    style: {
      enableBackground: "new 0 0 182 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#86BC25;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.8,29c0-2.7,2.2-4.8,4.8-4.8c2.7,0,4.8,2.2,4.8,4.8s-2.2,4.8-4.8,4.8S171.8,31.7,171.8,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.6,16.1c0,5.6-1.4,9.8-4.4,12.8s-7.2,4.5-12.6,4.5H0V0.1h11.2c5.3,0,9.3,1.3,12.1,4.1 C26.2,6.9,27.6,10.9,27.6,16.1 M18.4,16.4c0-3.1-0.6-5.3-1.8-6.8c-1.1-1.4-3-2.2-5.4-2.2H8.8v18.6h2c2.7,0,4.6-0.8,5.9-2.4 C17.8,22,18.4,19.6,18.4,16.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    className: "st1",
    width: 8.3,
    height: 33.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.4,20.9c0,4-1,7.2-3.2,9.5s-5.2,3.4-9,3.4c-3.7,0-6.6-1.1-8.8-3.5c-2.2-2.4-3.3-5.5-3.3-9.4 c0-4,1-7.2,3.2-9.4c2.2-2.3,5.2-3.4,9-3.4c2.4,0,4.5,0.5,6.3,1.5c1.9,1,3.2,2.5,4.2,4.4C92,16.1,92.4,18.3,92.4,20.9 M76.7,20.9 c0,2.2,0.3,3.7,0.8,4.8c0.5,1.1,1.4,1.6,2.8,1.6s2.2-0.5,2.8-1.6c0.5-1.1,0.8-2.8,0.8-4.8c0-2.2-0.3-3.7-0.8-4.8 c-0.5-1-1.4-1.6-2.8-1.6c-1.2,0-2.2,0.5-2.8,1.6C77,17.2,76.7,18.7,76.7,20.9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    y: 8.5,
    className: "st1",
    width: 8.3,
    height: 24.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    className: "st1",
    width: 8.3,
    height: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121,27c1.1,0,2.5-0.3,4-0.8v6.3c-1.1,0.5-2.2,0.8-3.2,1c-1,0.2-2.2,0.3-3.6,0.3c-2.8,0-4.8-0.7-6.1-2.2 c-1.2-1.4-1.9-3.6-1.9-6.5V14.9h-2.9V8.5h2.9V2.3l8.4-1.4v7.8h5.4V15h-5.4v9.6C118.8,26.3,119.5,27,121,27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.4,27c1.1,0,2.5-0.3,4-0.8v6.3c-1.1,0.5-2.2,0.8-3.2,1c-1,0.2-2.2,0.3-3.6,0.3c-2.8,0-4.8-0.7-6.1-2.2 c-1.2-1.4-1.9-3.6-1.9-6.5V14.9h-2.9V8.5h2.9V2.2l8.4-1.3v7.8h5.4V15h-5.4v9.6C138.1,26.3,138.9,27,140.4,27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.8,11c-2-2-4.8-2.9-8.4-2.9c-3.8,0-6.8,1.1-8.9,3.4c-2.1,2.3-3.1,5.5-3.1,9.7c0,4,1.1,7.2,3.3,9.4 c2.3,2.2,5.4,3.3,9.4,3.3c2,0,3.6-0.1,5-0.4c1.3-0.3,2.8-0.7,4-1.4l-1.2-5.6c-0.9,0.4-1.9,0.7-2.7,0.9c-1.2,0.3-2.6,0.4-4,0.4 c-1.6,0-2.9-0.4-3.8-1.1c-0.9-0.8-1.4-1.9-1.4-3.3h14.9v-3.9C169.8,15.8,168.7,13,166.8,11 M155,17.9c0.1-1.3,0.5-2.4,1.1-3 c0.6-0.6,1.4-0.9,2.5-0.9c1,0,2,0.3,2.6,1c0.6,0.7,0.9,1.6,1,2.9H155z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.5,11c-2.1-2-4.8-2.9-8.4-2.9c-3.8,0-6.8,1.1-8.9,3.4s-3.1,5.5-3.1,9.7c0,4,1.1,7.2,3.3,9.4 c2.3,2.2,5.4,3.3,9.4,3.3c2,0,3.6-0.1,5-0.4c1.3-0.3,2.8-0.7,4-1.4l-1.2-5.7c-0.9,0.4-1.9,0.7-2.7,0.9c-1.2,0.3-2.6,0.4-4,0.4 c-1.6,0-2.9-0.4-3.8-1.1c-0.9-0.8-1.4-1.9-1.4-3.3h14.9v-3.8C53.5,15.8,52.4,13,50.5,11 M38.6,17.9c0.1-1.3,0.5-2.4,1.1-3 s1.4-0.9,2.5-0.9s2,0.3,2.6,1c0.6,0.7,0.9,1.6,1,2.9H38.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeloitte);
export default __webpack_public_path__ + "static/media/deloitte.d83ae52d94ffc33006738165b200f623.svg";
export { ForwardRef as ReactComponent };